import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { CommonModule } from "@angular/common";
import { IconModule } from "@shared/components/icon/icon.module";

export interface DeactivateTppDialogData {
	serviceCount: number;
}

@Component({
	selector: "app-deactivate-tpp-beneficiaries-confirmation-dialog",
	templateUrl: "./deactivate-tpp-beneficiaries-confirmation-dialog.component.html",
	styleUrls: ["./deactivate-tpp-beneficiaries-confirmation-dialog.component.scss"],
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule, IconModule]
})
export class DeactivateTppBeneficiariesConfirmationDialogComponent {
	data = inject<DeactivateTppDialogData>(MAT_DIALOG_DATA);

	get confirmationMessage(): string {
		return `You're about to deactivate <strong>${this.data.serviceCount} services</strong>.<br>All selected services will be marked as <strong>Failed</strong> and no<br>payments will be made to them.<br><br>Are you sure you want to continue?`;
	}
}
